<template>
  <div class="ccui-help-center">
    <div class="ccui-app-container">
      <div class="ccui-advanced-search-wrapper ccui-clearfix">
        <div class="ccui-search-wrapper ccui-clearfix">
          <!--普通搜索Begin-->
          <div class="ccui-tab-wrapper">
            <el-button
              type="table-top-active"
              style="cursor: default;"
              size="mini"
              >帮助中心</el-button
            >
          </div>

          <!--普通搜索End-->
        </div>
      </div>
      <div class="ccui-help-content-box">
        <ul>
          <li>
            <img src="@/basa/assets/images/commonProblem.png" alt="" />
            <dl>
              <dt>常见问题</dt>
              <dd>您有问题可先看这里</dd>
            </dl>
            <el-button
              size="mini"
              type="primary"
              @click="goCommonProblem"
              :disabled="$store.state.user.userDetal.commonQuestion === ''"
              >点此查看</el-button
            >
          </li>
          <li>
            <img src="@/basa/assets/images/usersManual.png" alt="" />
            <dl>
              <dt>用户手册</dt>
              <dd>爱学习的人都会来看看这里</dd>
            </dl>
            <el-button
              size="mini"
              type="primary"
              @click="goUsersManual"
              :disabled="$store.state.user.userDetal.userManual === ''"
              >点此查看</el-button
            >
          </li>
          <li>
            <img src="@/basa/assets/images/onlineService.png" alt="" />
            <dl>
              <dt>在线客服</dt>
              <dd>在线解答您的咨询，高效、便捷</dd>
            </dl>
            <el-button
              size="mini"
              type="primary"
              @click="goOnlineService"
              :disabled="$store.state.user.userDetal.onlineConsultation === ''"
              >点此咨询</el-button
            >
          </li>
          <li>
            <img src="@/basa/assets/images/proposal.png" alt="" />
            <dl>
              <dt>提建议</dt>
              <dd>对{{ $store.state.user.userDetal.agentName }}应用提建议</dd>
            </dl>
            <el-button size="mini" type="primary" @click="goProposal"
              >我要留言</el-button
            >
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "heplCenter",
  computed: {
    changeRole(roleType) {
      return function(roleType) {
        /** do something */
        return roleType !== 1 && roleType !== 0;
      };
    }
  },
  data() {
    return {
      appId: "0"
    };
  },
  created() {
    this.$store.dispatch("setShowSimpleFooter", true);
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("setShowSimpleFooter", false);
    next();
  },
  methods: {
    goCommonProblem() {
      // this.$router.push("/helpAndSupport/helpProblem");
      window.open(this.$store.state.user.userDetal.commonQuestion);
    },
    goUsersManual() {
      // this.$router.push("/helpAndSupport/helpManual");
      window.open(this.$store.state.user.userDetal.userManual);
    },
    goOnlineService() {
      window.open(this.$store.state.user.userDetal.onlineConsultation);
    },
    goProposal() {
      console.log("languageChangeHandler1");
      this.resetSetItem("languageChangeHandler1", true);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/config/styles/variables.scss";
.helpContentBox {
  overflow: hidden;
  margin: 5px 28px 0;
}
.helpContentBox ul {
  width: 100%;
  overflow: hidden;
}
.helpContentBox ul li {
  width: calc(50% - 30px);
  height: 120px;
  border: 1px solid #e3e3e3;
  border-radius: 2px;
  float: left;
  margin-bottom: 20px;
  box-sizing: border-box;
  padding: 22px 20px 20px;
  position: relative;
}
.helpContentBox ul li:nth-child(2n) {
  margin-left: 56px;
}
.helpContentBox ul li img {
  width: 76px;
  height: 76px;
  display: inline-block;
  vertical-align: -20px;
}
.helpContentBox ul li dl {
  margin-left: 14px;
  display: inline-block;
}
.helpContentBox ul li dl dt {
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #4a4a4a;
  letter-spacing: 0;
  margin-bottom: 10px;
}
.helpContentBox ul li dl dd {
  font-size: 13px;
  font-family: PingFangSC-Regular;
  font-size: 13px;
  color: #4a4a4a;
  letter-spacing: 0;
}
/deep/ .el-button--primary {
  padding: 0 20px;
  height: 28px;
  float: right;
  margin-top: 30px;
}
</style>
